import { all } from 'redux-saga/effects';
import { getShipmentStatusSaga, ShipmentNumberSaga } from '../Sagas';

export function* rootSaga() {
  yield all([
    getShipmentStatusSaga(),
    ShipmentNumberSaga(),
  ])
}